import * as React from 'react'

interface TimePickerContextType {
  openPickerId: string | null
  setOpenPickerId: (id: string | null) => void
}

const TimePickerContext = React.createContext<TimePickerContextType | undefined>(undefined)

export function TimePickerProvider({ children }: { children: React.ReactNode }) {
  const [openPickerId, setOpenPickerId] = React.useState<string | null>(null)

  return (
    <TimePickerContext.Provider value={{ openPickerId, setOpenPickerId }}>
      {children}
    </TimePickerContext.Provider>
  )
}

export function useTimePicker() {
  const context = React.useContext(TimePickerContext)
  if (!context) {
    throw new Error('useTimePicker must be used within a TimePickerProvider')
  }
  return context
}
